export default class ViewPort {
  constructor(public lng: number, public lat: number, public zoom: number) {}
}
